import { Text } from '@fluentui/react';
import { Link } from '@micro-frontend-react/employee-experience/lib/Link';

export const UserPortalsCardList = styled.div`
  display: flex;
  flex-flow: row wrap;
  column-gap: 40px;
  row-gap: 40px;
`;

export const CardContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex-shrink: 0;
`;

export const HeaderContainer = styled.div`
  display: flex;
  flex-direction: column;
  background-color: #f2f9ff;
  width: 600px; // width: 716px;
  height: 156px;

  box-shadow: #00000022 0px 1.6px 3.6px 0px, #0000001c 0px 0.3px 0.9px 0px;
  border-radius: 2px;
  border: 1px solid transparent;
`;

export const CardTitle = styled(Text)`
  display: flex;
  padding-top: 45px;
  padding-bottom: 10px;
  padding-left: 34px;

  font-size: 18px;
  font-style: normal;
  font-weight: 600;
  line-height: 24px;
  color: #323130;
`;

export const CardDescription = styled(Text)`
  width: 350px;
  padding-left: 34px;

  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px;
  color: #605e5c;
`;

export const BodyContainer = styled.div`
  display flex;
  flex-direction: row;
  justify-content: space-between;
  background: #FFFFFF;
  width: 600px; // width: 716px;
  padding-top: 20px;
  padding-bottom: 20px;
  padding-left: 16px;
  padding-right: 16px;

  box-shadow: #00000022 0px 1.6px 3.6px 0px, #0000001c 0px 0.3px 0.9px 0px;
  border-radius: 2px;
  border: 1px solid transparent;
`;

export const BodyDivider = styled.div`
  display: flex;
  width: 600px; // width: 716px;
  height: 1px;
  background: #e5e5e5;
`;

export const BodyLeftContainer = styled.div`
  display: flex;
  flex-direction: row;
`;

export const BlueRectangle = styled.div`
  display: flex;
  width: 2px;
  height: 61px;
  flex-shrink: 0;
  background: linear-gradient(0deg, #0078d4 0%, #0078d4 100%), #646464;
`;

export const InfoContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding-left: 16px;
`;

export const NameLink = styled(Link)`
  font-size: 14px;
  font-weight: 600;
  line-height: 20px;
  color: #0078d4;
`;

export const ServiceTreeNameText = styled(Text)`
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  color: #323130;
`;

export const AddRequestLink = styled(Link)`
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  color: #0064bf;
`;

export const NameText = styled(Text)`
  font-size: 14px;
  font-weight: 600;
  line-height: 20px;
  color: #0078d4;
`;

export const AddRequestText = styled(Text)`
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  color: #0064bf;
`;

export const FooterContainer = styled.div`
  display: flex;
  flex-direction: row;
  background-color: #ffffff;
  width: 600px; // width: 716px;
  height: 72px;
  padding-left: 16px;
  column-gap: 20px;
  align-items: center;

  box-shadow: #00000022 0px 1.6px 3.6px 0px, #0000001c 0px 0.3px 0.9px 0px;
  border-radius: 2px;
  border: 1px solid transparent;
`;
